module.exports = __webpack_public_path__ + "static/img/baas_chance_2.ff784ac.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_chance_2.svg
// module id = cR1q
// module chunks = 0